<template>
    <div class="sticky-header">
        <section>
            <!-- sidebar left start-->
            <div class="sidebar-left">
                <div class="sidebar-left-info">

                    <div class="user-box">
                        <div class="text-center text-white sidebar__user-info">
                            <div>{{ userInfo.correo }}</div>
                            <div>{{ userInfo.perfil }}</div>
                        </div>
                    </div>
                    <hr class="mb-2 mt-2">
                    <!--sidebar nav start-->
                    <ul class="side-navigation">
                        <li>
                            <h3 class="navigation-title">Menú</h3>
                        </li>
                        <li>
                            <a @click="goTo('/menu')">
                                <i class="mdi mdi-home"></i> 
                                    <span>Inicio</span>
                            </a>
                        </li>
                        <li>
                            <a @click="goTo('/consulta/mis-pagos')">
                                <i class="mdi mdi-sync"></i>
                                <span>Mis transacciones</span></a>
                        </li>
                        <li v-if="!isOnApp">
                            <a @click="goTo('/reportes')">
                                <i class="mdi mdi-chart-bar"></i> <span>Reportes</span>
                            </a>
                        </li>
                        <li v-if="!isOnApp && showConfig">
                            <a @click="goTo('/configuracion')">
                                <i class="fa fa-cog"></i> <span>Configuración</span>
                            </a>
                        </li>
                        <li v-if="isOnApp">
                            <a @click="cierresVisanet">
                                <i class="mdi mdi-lock"></i> 
                                <span>Cierre Visanet</span>
                            </a>
                        </li>
                        <li>
                            <a @click="logoutSession">
                                <i class="mdi mdi-logout"></i> 
                                <span> Cerrar sesión</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div><!-- sidebar left end-->
            <div id="body-content" class="body-content">
                <div class="header-section">
                    <!--logo and logo icon start-->
                    <div class="logo">
                        <a href="/">
                            <span class="logo-img">
                                <img src="assets/images/Logo_icon.png" alt="" height="40">
                            </span>
                            <span class="brand-name">El Roble</span>
                            <!--<i class="fa fa-maxcdn"></i>-->
                        </a>
                    </div>

                    <!--toggle button start-->
                    <a class="toggle-btn" @click="toogleBar">
                    <i class="fa fa-bars" aria-hidden="true"></i></a>
                    <!--toggle button end-->

                    <!--mega menu start-->
                    <!--<div id="navbar-collapse-1" class="navbar-collapse collapse mega-menu">
                        <ul class="nav navbar-nav">
                            &lt;!&ndash; Classic dropdown &ndash;&gt;
                            <li class="dropdown">
                                <a href="javascript:;" data-toggle="dropdown" class=""> English
                                    <i class="mdi mdi-chevron-down"></i> </a>
                                <ul role="menu" class="dropdown-menu language-switch">
                                    <li>
                                        <a tabindex="-1" href="javascript:;"> German </a>
                                    </li>
                                    <li>
                                        <a tabindex="-1" href="javascript:;"> Italian </a>
                                    </li>
                                    <li>
                                        <a tabindex="-1" href="javascript:;"> French </a>
                                    </li>
                                    <li>
                                        <a tabindex="-1" href="javascript:;"> Spanish </a>
                                    </li>
                                    <li>
                                        <a tabindex="-1" href="javascript:;"> Russian </a>
                                    </li>
                                </ul>
                            </li>
                            &lt;!&ndash; Classic list &ndash;&gt;
                            <li>
                                <form class="search-content" action="index.html" method="post">
                                    <input type="text" class="form-control mt-3" name="keyword" placeholder="Search...">
                                    <span class="search-button"><i class="ti ti-search"></i></span>
                                </form>
                            </li>
                        </ul>
                    </div>-->
                    <!--mega menu end-->

                    <div class="notification-wrap">
                        <!--right notification start-->
                        <div class="right-notification">
                            <ul class="notification-menu">
                                <!--<li>
                                    <a href="javascript:;" class="notification" data-toggle="dropdown">
                                        <i class="mdi mdi-bell-outline"></i>
                                        <span class="badge badge-success">4</span>
                                    </a>
                                    <ul class="dropdown-menu mailbox dropdown-menu-right">
                                        <li>
                                            <div class="drop-title">Notifications</div>
                                        </li>
                                        <li class="notification-scroll">
                                            <div class="message-center">
                                                <a href="#">
                                                    <div class="user-img">
                                                        <i class="ti ti-star"></i>
                                                    </div>
                                                    <div class="mail-contnet">
                                                        <h6>Jane A. Seward</h6>
                                                        <span class="mail-desc">Iwon meddle and...</span>
                                                    </div>
                                                </a>
                                                <a href="#">
                                                    <div class="user-img">
                                                        <i class="ti ti-heart"></i>
                                                    </div>
                                                    <div class="mail-contnet">
                                                        <h6>Michael W. Salazar</h6>
                                                        <span class="mail-desc">Lovely gide learn for you...</span>
                                                    </div>
                                                </a>
                                                <a href="#">
                                                    <div class="user-img">
                                                        <i class="ti ti-image"></i>
                                                    </div>
                                                    <div class="mail-contnet">
                                                        <h6>David D. Chen</h6>
                                                        <span class="mail-desc">Send his new photo...</span>
                                                    </div>
                                                </a>
                                                <a href="#">
                                                    <div class="user-img">
                                                        <i class="ti ti-bell"></i>
                                                    </div>
                                                    <div class="mail-contnet">
                                                        <h6>Irma J. Hendren</h6>
                                                        <span class="mail-desc">6:00 pm our meeting so...</span>
                                                    </div>
                                                </a>
                                            </div>
                                        </li>
                                        <li>
                                            <a class="text-center bg-light" href="javascript:void(0);">
                                                <strong>See all notifications</strong>
                                            </a>
                                        </li>
                                    </ul>
                                </li>-->
                                <!--<li>
                                    <a href="javascript:;" data-toggle="dropdown">
                                        <img src="assets/images/avatar.png">
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right profile-menu">
                                        <a class="dropdown-item" href="#"><i class="mdi mdi-account-circle m-r-5 text-muted"></i> Perfil</a>
                                        <a class="dropdown-item" href="#"><span class="badge badge-success pull-right">5</span><i class="mdi mdi-settings m-r-5 text-muted"></i> Settings</a>
                                        <a class="dropdown-item" href="#"><i class="mdi mdi-logout m-r-5 text-muted"></i> Cerrar sesión</a>
                                    </div>

                                </li>-->
                            </ul>
                        </div><!--right notification end-->
                    </div>
                </div>
                <div class="container-fluid app-main" style="max-width: 900px">
                    <slot/>
                </div>
                <footer class="footer">
                    2026 &copy; - Seguros El Roble - V.{{version}}
                </footer>
            </div>
        </section>

    </div>

</template>

<script>

import {mapGetters, mapMutations} from "vuex";
import API from "src/core/Api";
import {store} from "src/store";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";
import Tools from "src/core/Tools";

export default {
    props: {},
    components: {},
    data() {
        return {
            androidBridge: false,
            isOnApp: false,
            showConfig: false,
            userInfo: {},
            version: "",
        };
    },
    mounted() {
        this.version = CONFIG.getVersion();
        this.userInfo = this.AuthGetUserInfo();
        this.androidBridge = new AndroidBridge();
        this.isOnApp = this.androidBridge.appEnabled();

        if (CONFIG.getEnvironment() !== 'PRODUCTION') {
            document.getElementById('body-content').style.background = '#ffddcf';
        }

        this.showConfig = Tools.checkAccess('configuracion/pos');
        console.log(this.showConfig);
        
        // En móviles (menos de 600px), colapsar el sidebar por defecto
        if (window.innerWidth < 600) {
            document.body.classList.add('sidebar-collapsed');
        }
    },
    methods: {
        ...mapGetters(["AuthGetUserInfo"]),
        ...mapMutations(["Logout"]),
        goTo(dir) {
            this.$router.push(dir);
            this.toogleBar();
        },
        logoutSession() {
            //console.log('asdfadsf');
            const self = this;
            API.send('GET', 'auth/logout', false,
                function (response) {
                    store.dispatch('coreHideLoading');
                    self.Logout();
                    window.location.href = '/';
                },
                function () {
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })

        },
        toogleBar() {
            const body = jQuery('body');
            const bodyposition = body.css('position');

            if (bodyposition != 'relative') {

                if (!body.hasClass('sidebar-collapsed')) {
                    body.addClass('sidebar-collapsed');
                    jQuery('.side-navigation ul').attr('style', '');

                }
                else {
                    body.removeClass('sidebar-collapsed chat-view');
                    jQuery('.side-navigation li.active ul').css({display: 'block'});
                }
            }
            else {

                if (body.hasClass('sidebar-open'))
                    body.removeClass('sidebar-open');
                else
                    body.addClass('sidebar-open');
            }
        },
        cierresVisanet() {
            if (confirm('Se realizará el cierre en Visanet, no podrá anular las transacciones cerradas, ¿desea continuar?')) {
                this.androidBridge.VisanetPayAppCierre();
            }
        }
    },
};
</script>
